import React, { useEffect, useMemo, useRef, useState } from 'react'
import "./sms-portal.scss"
import PatientSection from '../../components/sms-portal/name-section'
import { showErrorToast, showSuccessToast } from '../../utils/toaster-alert'
import { get, post, put, del } from '../../utils/fetchAPI'
import { useDispatch, useSelector } from 'react-redux'
import CustomModal from '../../components/common/modal/modal'
import { ResearchTagAssign } from '../../components/settings/resarch-tags/researchTagAssign'
import Pagination from "react-js-pagination";
import VisitHistorySection from './visit-history'
import SearchSelect from '../../components/common/updated-input/createble-search-select/search-select'
import { ToolTip } from '../../components/common/tooltip/tooltip'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PatientHistory from '../../components/prescription/patient-history/patient-history'

export const Resaerch = () => {
    const [selectedTgas, setSelecteTags] = useState([])
    const [selectedTagIds, setSelecteTagIds] = useState([])
    const [patients, setPatients] = useState([])
    const [paginateData, setPaginateData] = useState({ currentPage: 1, perPage: 20, total: 0 })
    const [selectedPatient, setSelectedPatient] = useState("")
    const [visits, setVisits] = useState([])
    const [selectedOption, setSelectedOption] = useState("diagnosis")
    const [selectedDiagnosisType, setSelectedDiagnosisType] = useState("provisional")
    const [diagnosisList, setDiagnosisList] = useState([])
    const [selectedDignosis, setSelecteDignosis] = useState([])
    const [selectedDignosisIds, setSelecteDignosisIds] = useState([])
    const { user } = useSelector((state) => state.auth);
    let timeoutIdRef = useRef()
    function extractIds(data) {
        return data.map(item => item._id);
    }



    useEffect(() => {
        // if (visitDetails?.doctor) {
        //     getProvisionalDxList(visitDetails?.doctor)
        //     getDifferentialDxList(visitDetails?.doctor)
        // }
        if (selectedDiagnosisType == "provisional") {
            getProvisionalDxList(user?.user?._id)
        }
        else if (selectedDiagnosisType == "differential") {
            getDifferentialDxList(user?.user?._id)
        }

    }, [selectedDiagnosisType])


    const handleTags = async (value) => {
        let tagIds = extractIds(selectedTgas || [])
        if (tagIds?.includes(value?._id)) {
            showErrorToast("This tag already added")
        }
        else {
            tagIds.push(value?._id)
            setSelecteTagIds(tagIds)
            await getPatientList(tagIds)
            setSelecteTags([...selectedTgas, value])
            // showSuccessToast("Tag added successfully")
        }

    }

    const removeTags = async (value) => {
        let tagIds = extractIds(selectedTgas || [])
        if (tagIds?.includes(value?._id)) {
            const updatedIds = tagIds.filter(item => item !== value?._id);
            const updatedTags = selectedTgas.filter(item => item?._id !== value?._id);
            setSelecteTagIds(updatedIds)
            setSelecteTags(updatedTags)
            await getPatientList(updatedIds)
            showSuccessToast("Tag removed successfully")
        }
        else {
            showErrorToast("Not removed")
        }

    }




    const getPatientList = async (ids = [], current_page = paginateData?.currentPage) => {
        await get(`/tags/patient/list?tags=${ids?.join(",") || ""}&current_page=${current_page}&docotorId=${user?.user?._id}`)
            .then((res) => {
                if (res?.status == 200) {
                    setPaginateData({ ...paginateData, total: res?.data?.total, currentPage: res?.data?.currentPage })
                    setPatients(res?.data?.patients)
                    setSelectedPatient({})
                }
            })
            .catch((error) => {
                setPatients([])
                setVisits([])
                setSelectedPatient({})
                setPaginateData({ currentPage: 1, perPage: 20, total: 0 })
            });
    }


    function getDxString(data) {
        let diagnosis = ""
        if (data?.length > 0) {
            for (let i = 0; i < data?.length; i++) {
                diagnosis = diagnosis + (data[i]?.provisionalDx || data[i]?.differentialDx) + (i !== (data?.length - 1) ? "$" : "")
            }
        }
        return diagnosis
    }

    const getVisitList = async (value) => {
        setSelectedPatient(value)

        if (selectedOption == "tags") {
            await get(`/tags/patient/visits/${value?._id}?tags=${selectedTagIds?.join(",")}`)
                .then((res) => {
                    if (res?.status == 200) {
                        setVisits(res?.data?.visits)
                    }
                })
                .catch((error) => {
                    // setIsSubmitting(false);
                    setVisits([])
                });
        }

        else {
            const diagnosis = await getDxString(selectedDignosis)
            await get(`/diagnosis/patient/visits/${value?._id}?diagnosis=${diagnosis || ""}&diagnosis_type=${selectedDiagnosisType}`)
                .then((res) => {
                    if (res?.status == 200) {
                        setVisits(res?.data?.visits)
                    }
                })
                .catch((error) => {
                    // setIsSubmitting(false);
                    setVisits([])
                });
        }

    }


    const getPatientListUsingDiagnosis = async (ids = [], current_page = paginateData?.currentPage) => {
        const diagnosis = await getDxString(ids)

        await get(`/diagnosis/patient/list?diagnosis=${diagnosis || ""}&diagnosis_type=${selectedDiagnosisType}&current_page=${current_page}&docotorId=${user?.user?._id}`)
            .then((res) => {
                if (res?.status == 200) {
                    setPaginateData({ ...paginateData, total: res?.data?.total, currentPage: res?.data?.currentPage })
                    setPatients(res?.data?.patients)
                    setSelectedPatient({})
                }
            })
            .catch((error) => {
                setPatients([])
                setVisits([])
                setSelectedPatient({})
                setPaginateData({ currentPage: 1, perPage: 20, total: 0 })
            });
    }


    const handleSubmitDiagnosis = async (value) => {
        let diagnosisIds = extractIds(selectedDignosis || [])
        if (diagnosisIds?.includes(value?._id)) {
            showErrorToast("Already added")
        }
        else {
            diagnosisIds.push(value?._id)
            setSelecteDignosisIds(diagnosisIds)
            await getPatientListUsingDiagnosis([...selectedDignosis, value])
            setSelecteDignosis([...selectedDignosis, value])
            // showSuccessToast("Tag added successfully")
        }

    }

    const removeDiagnosais = async (value) => {
        let diagnosisIds = extractIds(selectedDignosis || [])
        if (diagnosisIds?.includes(value?._id)) {
            const updatedIds = diagnosisIds.filter(item => item !== value?._id);
            const updatedDiagnosis = selectedDignosis.filter(item => item?._id !== value?._id);
            setSelecteDignosisIds(updatedIds)
            setSelecteDignosis(updatedDiagnosis)
            await getPatientListUsingDiagnosis(updatedDiagnosis)
            showSuccessToast("Diagnosis removed successfully")
        }
        else {
            showErrorToast("Not removed")
        }

    }


    const setOptionFun = (event) => {
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(async () => {
            if (selectedDiagnosisType == "differential") {
                getDifferentialDxList(user?.user?._id, event.target.value)
            }
            else {
                getProvisionalDxList(user?.user?._id, event.target.value)
            }
        }, 700);

    }


    const getProvisionalDxList = async (doctorId, search = "") => {

        await get(`/doctor/provisionalDx/list/${doctorId}${search ? (`?search=${search}`) : ""}`)
            .then((res) => {
                if (res?.status == 200) {
                    setDiagnosisList(res?.data)
                }
            })
            .catch((error) => {
                // setIsSubmitting(false);
            });;
    }
    const getDifferentialDxList = async (doctorId, search = "") => {

        await get(`/doctor/differentialDx/list/${doctorId}${search ? (`?search=${search}`) : ""}`)
            .then((res) => {
                if (res?.status == 200) {
                    setDiagnosisList(res?.data)
                }
            })
            .catch((error) => {
                // setIsSubmitting(false);
            });;
    }


    const resetAll = () => {
        setPatients([])
        setVisits([])
        setSelectedPatient({})
        setPaginateData({ currentPage: 1, perPage: 20, total: 0 })
        setSelecteDignosis([])
    }



    return (
        <section className='sms-portal'>
            <div className='name-section'>
                <div className="col-12 mt-2">
                    <div className=" d-flex radio-button">
                        <div
                            role="group"
                            aria-labelledby="my-radio-group"
                            className="d-flex px-0 mx-0"
                        >
                            <label className=" d-flex mr-3">
                                <input
                                    checked={selectedOption == "diagnosis" ? true : false}
                                    type="radio"
                                    name="radio-group"
                                    value="diagnosis"
                                    onClick={() => {
                                        resetAll()
                                        setSelectedOption("diagnosis")
                                    }}
                                />
                                <span className="ml-2 ">By Diagnosis</span>
                            </label>
                            <label className=" d-flex mr-3">
                                <input
                                    checked={selectedOption == "tags" ? true : false}
                                    type="radio"
                                    name="radio-group"
                                    value="tags"
                                    onClick={() => {
                                        resetAll()
                                        setSelectedOption("tags")
                                    }}
                                />
                                <span className="ml-2 ">By Tags</span>
                            </label>
                        </div>
                    </div>
                </div>
                {selectedOption == "tags" && <ResearchTagAssign removeTags={removeTags} visitDetails={{ researchTag: selectedTgas }} handleTags={handleTags} className="resaerch-section" placeholder="Select tag" />}

                {selectedOption == "diagnosis" && <div className='d-flex'>
                    <div style={{ width: "75%" }}>
                        <SearchSelect uniqKey={1} borderColor='#13AC81' handleSubmit={handleSubmitDiagnosis} isSearching={false} setOptionFun={setOptionFun} options={diagnosisList || []} placeHolder={"select"}></SearchSelect>
                    </div>
                    <select
                        style={{ widows: "25%", fontSize: "13px" }}
                        onChange={(e) => {
                            setSelecteDignosis([])
                            setSelecteDignosisIds([])
                            setSelectedDiagnosisType(e.target.value);
                        }}
                        value={selectedDiagnosisType}
                    >
                        <option value={"differential"}> Differential</option>
                        <option value={"provisional"}>Provisional </option>
                    </select>{" "}
                </div>}
                {
                    selectedOption == "diagnosis" && <div className='assign-diagnosis-contaner'>
                        {
                            selectedDignosis?.length > 0 && selectedDignosis?.map((data, index) => {
                                return (
                                    <div className='px-2 diagnosis' key={index}>
                                        <p className='d-block'>{data?.differentialDx || data?.provisionalDx}  <FontAwesomeIcon onClick={() => { removeDiagnosais(data) }} className="diagnosis-delete" style={{ fontSize: "11px" }} icon={faTrash} /></p>

                                    </div>
                                )
                            })
                        }
                    </div>
                }
                {<div className='name-list'>
                    <div>
                        {patients?.length > 0 && <p className='border px-1 py-0 my-0' style={{ color: "#12ab81", fontSize: "14px", height: "25px" }}>Patient list</p>}
                    </div>
                    {patients?.length > 0 && patients?.map((data) => {
                        return (
                            <div onClick={() => { getVisitList(data) }} className={selectedPatient?._id == data?._id ? "individual-name  name" : "individual-name"} key={data?._id}>
                                <p style={{ fontSize: "13px" }} className='py-0 my-0'>{data?.name}</p>
                                <p style={{ fontSize: "12px" }} className='py-0 my-0'>{data?.phone}</p>
                            </div>
                        )
                    })}
                    {patients?.length == 0 && <small className='mx-1'>Plese select</small>}
                </div>}

                <div className='d-flex justify-content-center'>
                    {patients?.length > 0 && <Pagination
                        activePage={parseInt(paginateData?.currentPage)}
                        itemsCountPerPage={parseInt(paginateData?.perPage)}
                        totalItemsCount={parseInt(paginateData?.total)}
                        // pageRangeDisplayed={5}
                        onChange={(currentPage) => {
                            if (selectedOption == "tags")
                                getPatientList(selectedTagIds, currentPage)
                            else getPatientListUsingDiagnosis(selectedDignosis, currentPage)
                            // index(currentPage, "", length);
                        }}
                        itemClass="page-item"
                        linkClass="page-link"
                    />}
                </div>
            </div>
            <div className='form-section'>
                <VisitHistorySection visits={visits} />
            </div>
            <div className="full-history mr-1" style={{ height: "95vh" }}>
                {selectedPatient?._id && <PatientHistory referredBy={""} patientId={selectedPatient?._id}></PatientHistory>}
            </div>

        </section>
    )
}
